import { render } from "./Footer.m.vue?vue&type=template&id=e7d59f3a"
import script from "./Footer.m.vue?vue&type=script&lang=js"
export * from "./Footer.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__